'use strict';

/**
 * @desc Util for Media breakpoints used in JS
 */
const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 1024,
    xl: 1362
};

module.exports = breakpoints;
